import React from 'react';
import styled from 'styled-components';
import { Privilege } from '../../api';
import { PitchDetails } from '../../services/pitches';
import usePitches from './usePitches';
import Progress from '../Util/Progress';
import { useSnackbar } from 'notistack';
import { RouteComponentProps, Redirect } from 'react-router';
import PitchDetail from './PitchDetail';
import PitchSidemenu from './PitchSidemenu';
import useHasPrivilege from '../Util/useHasPrivilege';

type TParams = { pitch?: string };
interface Props extends RouteComponentProps<TParams> {}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;

const Container1 = styled.div`
  height: 100%;
`;

const Container2 = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
  display: inline-block;
`;

const PitchOverview: React.FunctionComponent<Props> = (props) => {
  const { pitches, loading, error } = usePitches();
  const { enqueueSnackbar } = useSnackbar();
  const canWritePitches = useHasPrivilege(Privilege.WritePitches);

  if (error) {
    enqueueSnackbar('Failed to load pitches', { variant: 'error', autoHideDuration: 3000 });
    return <Progress />;
  }
  if (loading || !pitches) {
    return <Progress />;
  }
  if (!props.match.params.pitch) {
    if (pitches.length > 0) {
      return <Redirect to={'/pitch/' + pitches[0].id} />;
    } else if (canWritePitches) {
      return <Redirect to={'/pitch/new'} />;
    }
  }

  let pitch: PitchDetails | undefined = pitches.find((pitch) => String(pitch.id) === props.match.params.pitch);
  if (props.match.params.pitch === 'new') {
    pitch = {
      id: -1,
      name: '',
      type: 'FullPitchExtendedModel',
      fieldLength: 105000,
      fieldWidth: 68000,
      latitude: 52.22057,
      longitude: 6.88992,
      timeZone: 'Europe/Amsterdam',
    };
  }

  return (
    <Wrapper>
      <Container1>
        <PitchSidemenu />
      </Container1>
      <Container2>{pitch && <PitchDetail pitch={pitch} edit={props.match.params.pitch === 'new'} />}</Container2>
    </Wrapper>
  );
};

export default PitchOverview;
